import React from 'react';
import { Lock, Phone, Plug2, Send } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import TasksManager from './TasksManager';

const SHOW_PAGE_HEADER = false;
const SHOW_PHONE_PROVIDERS = false;
const SHOW_INTEGRATION_REQUEST_CTA = false;

const Integrations = ({ dateRange }) => {

  // Список телефонных систем в разработке
  const phoneProviders = [
    {
      id: 'telefin',
      name: 'Телфин',
      description: 'Облачная АТС для бизнеса',
      status: 'В разработке'
    },
    {
      id: 'mango',
      name: 'Mango Office',
      description: 'Виртуальная телефония',
      status: 'В разработке'
    },
    {
      id: 'rostelekom',
      name: 'Ростелеком',
      description: 'Корпоративная телефония',
      status: 'В разработке'
    },
    {
      id: 'megafon',
      name: 'МегаФон',
      description: 'Корпоративные решения связи',
      status: 'В разработке'
    }
  ];

  const handleIntegrationRequest = () => {
    window.alert('Заявка отправлена. Мы свяжемся с вами в ближайшее время.');
  };

  return (
    <div className="space-y-6">
      {/* Заголовок */}
      {SHOW_PAGE_HEADER && (
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Интеграции</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Подключите вашу телефонную систему для автоматического импорта звонков
          </p>
        </div>
      )}

      {/* Карточки телефонных систем */}
      {SHOW_PHONE_PROVIDERS && (
        <div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Телефонные системы
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {phoneProviders.map((provider) => (
              <Card
                key={provider.id}
                className="bg-gray-100 dark:bg-gray-800 border-gray-300 dark:border-gray-700 opacity-75 relative overflow-hidden"
              >
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <Phone className="h-8 w-8 text-gray-500 dark:text-gray-400" />
                    <Lock className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                  </div>
                  <CardTitle className="text-lg text-gray-700 dark:text-gray-300">
                    {provider.name}
                  </CardTitle>
                  <CardDescription className="text-gray-600 dark:text-gray-400 text-sm">
                    {provider.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex items-center justify-center py-2">
                    <span className="text-sm font-medium text-gray-600 dark:text-gray-400 bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded-full">
                      {provider.status}
                    </span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}

        {/* CTA для заявки на интеграцию */}
        {SHOW_INTEGRATION_REQUEST_CTA && (
        <Card className="bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 border-blue-200 dark:border-blue-700">
            <CardContent className="py-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                        <div className="flex-shrink-0">
                            <Plug2 className="h-12 w-12 text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
                                Нужна интеграция с вашим провайдером?
                            </h3>
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Мы готовы реализовать интеграцию с любой телефонной системой
                            </p>
                        </div>
                    </div>
                    <Button
                        onClick={handleIntegrationRequest}
                        className="bg-blue-600 hover:bg-blue-700 text-white whitespace-nowrap"
                    >
                        <Send className="h-4 w-4 mr-2" />
                        Оставить заявку
                    </Button>
                </div>
            </CardContent>
        </Card>
        )}

      {/* Импорт звонков вручную */}
      <div className="space-y-4">
        <TasksManager dateRange={dateRange} />
      </div>
    </div>
  );
};

export default Integrations;
